import React from 'react';

import './InfoCard.scss';

export const InfoCard = ({ children }) => {
  return <div className='info-card'>{children}</div>;
};
